import React, { useState } from "react";
import PropTypes from "prop-types";
import { getData } from "../../../../serverRequest";
import LoadingSpinner from "../../../../components/Loadder";
import moment from 'moment';
import ProductWarrantyListTable from "../../../../components/Tables/ProductWarrantyListTable";
import { Link } from 'react-router-dom';

export default function ProductWarrantyList() {
    const [open, setOpen] = React.useState(true);
    const [totalProductsWarranty, setTotalProductsWarranty] = React.useState([]);
    const [loading, setLoading] = useState(true);
    const searchParams = new URLSearchParams(window.location.search);
    
    const ticketFilter = searchParams.get('filter');
    //console.log(ticketFilter);
    const toggleDrawer = () => {
      setOpen(!open);
    };
  
    const formatDate = (dateString) => {
      return moment(dateString).format('DD/MM/YYYY');
    };
  
    const filterProductWarrantyData = (products_warranty_data) => {
      //console.log(tickets_data);
      let totalproductwarranty = [];
      if(products_warranty_data){
        for (let i = 0; i < products_warranty_data.length; i++) {
            totalproductwarranty.push(products_warranty_data[i])
        }
      }
     
      setTotalProductsWarranty(totalproductwarranty);
      return ({ "total": totalproductwarranty})
    }
    React.useEffect(() => {
      async function fetchData() {
        let resData = await getData('/api/inventory/warranty/')
        let product_warranty_data = resData['data']['product_warranty_data']
        console.log(product_warranty_data);
        let productWarrantyData = await filterProductWarrantyData(product_warranty_data)
  
       
        setLoading(false);
      }
      fetchData();
  
  
    }, [])
    return (
        <>

            <main>
                <div className="relative block py-24 lg:pt-0 px-4">
                    <div className="rounded-t bg-white mb-0 px-6 py-6">
                        <div className="text-center flex justify-between">
                            <h6 className="text-blueGray-700 text-xl font-bold">Product Warranties</h6>
                            <Link to="/admin/inventory/productWarrantyForm">
                            <button
                                className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                                type="button"
                            >
                                Warranty
                            </button>
                            </Link>
                        </div>
                    </div>
                    {loading ? (
                        <LoadingSpinner></LoadingSpinner>
                    ) : (<>
                        <div
                            className={
                                "relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded " +
                                ("light" === "light" ? "bg-white" : "bg-lightBlue-900 text-white")
                            }
                        >

                            <div className="block w-full overflow-x-auto py-24 lg:pt-0 px-4">
                                {/* Projects table */}
                                <ProductWarrantyListTable totalProductWarranties={totalProductsWarranty}></ProductWarrantyListTable>

                            </div>
                        </div>
                    </>)}
                </div>
            </main>

        </>
    );
}
